


























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import intersectionWith from "lodash/intersectionWith";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  TreatmentMasterListsApi,
  TreatmentDatabasesApi,
  SetPoint,
  TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest,
  LocationsApiGetDetailLocationDatabaseRequest,
  GetLocationDatabaseDetailRequest,
  LocationsApi,
} from "../../../apis";
import ConfirmDialog from "../../components/user-management/ConfirmDialog.vue";
import { email } from "vee-validate/dist/rules";
import en from "vuetify/es5/locale/en";
import errorsRouter from "../../../router/modules/errors";
import VueI18n from "vue-i18n";
import AppliedLocationsDialog from "./AppliedLocationsDialog.vue";

export enum ACTION {
  VIEW = "VIEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
}

@Component({
  components: {
    MoreVertBtn,
    ConfirmDialog,
    AppliedLocationsDialog
  },
})
export default class DatabaseTab extends Vue {
  items: any[] = [];
  pagingOption: DataOptions | null = null;
  searchParam: any = {};
  totalRecord: number = 0;
  pageBeforeSort: number = 0;
  isShowAppliedLocationsDialog = false;

  productOptions = [];
  insectOptions = [];
  packageOptions = [];
  techniqueOptions = [];
  appliedLocations = [];

  get ACTIONS(): IAction[] {
    return [
      {
        titleName: this.$t("text.view"),
        titleStyle: "color: black; font-weight: 600",
        action: ACTION.VIEW,
      },
      {
        titleName: this.$t("text.edit"),
        titleStyle: "color: black; font-weight: 600",
        action: ACTION.EDIT,
        permission: {
          context: "TREATMENT_DATABASE_MANAGEMENT",
          action: "update",
        },
      },
      {
        titleName: this.$t("text.delete"),
        titleStyle: "color: red; font-weight: 600",
        action: ACTION.DELETE,
        permission: {
          context: "TREATMENT_DATABASE_MANAGEMENT",
          action: "delete",
        },
      },
    ];
  }

  headers = [] as DataTableHeader[];

  BASE_HEADER = [
    {
    text: this.$t("text.product"),
    value: "product",
    width: 200,
    class: ["tw-p-4", "column-sticky", "tw-left-0"],
    cellClass: ["column-sticky", "tw-left-0"]
  },
  {
    text: this.$t("text.pallet"),
    value: "isPallet",
    class: ["column-sticky", "tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
  },
  {
    text: this.$t("text.expiryTime"),
    value: "expiryTime",
    class: ["column-sticky", "tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
  },
  {
    text: this.$t("text.insect"),
    value: "insect",
    class: ["tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["tw-whitespace-no-wrap"],
  },
  {
    text: `${this.$t("text.package")} (KG)`,
    value: "package",
    class: ["tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["tw-whitespace-no-wrap"],
  },
  {
    text: this.$t("text.technique"),
    value: "technique",
    class: ["tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["tw-whitespace-no-wrap"],
  },
  {
    text: (this.$t("text.locations") as string).toLowerCase(),
    value: "locations",
    class: ["tw-capitalize", "tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["tw-whitespace-no-wrap"],
  },
  {
    text: this.$t("text.treatmentTime"),
    value: "treatmentTime",
    class: ["tw-whitespace-no-wrap", "tw-p-4"],
    cellClass: ["tw-whitespace-no-wrap"],
  },
  ] as DataTableHeader[];

  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;

  async mounted() {
    try {
      this.$util.showLoading();
      await this.handleGetMasterList();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.doSearch();
    }
  }

  updated() {
    this.frozenColumnsBuilder();
  }

  frozenColumnsBuilder() {
    const tableThs: any = document.querySelectorAll(
      ".treatment-database-table table thead tr th"
    );
    this.$nextTick(() => {
      if (!tableThs.length) return;
      const leftPxArr = [];
      for (let idx = 0; idx <= 1; idx++) {
        const headTh: any = document.querySelector(
          `table > thead > tr > th:nth-child(${idx + 2})`
        );
        const bodyTds: any = (numb) =>
          document.querySelectorAll(
            `table > tbody > tr > td:nth-child(${numb})`
          );
        leftPxArr.push(tableThs[idx].getBoundingClientRect().width);
        const leftPx = leftPxArr.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );
        if (headTh) {
          headTh.style.left = leftPx + "px";
          // headTh.style.backgroundColor = `rgb(254 254 254)`;
        }
        const bodyTs2 = bodyTds(idx + 2);
        if (bodyTs2) {
          bodyTs2.forEach((td) => {
            td.style.left = leftPx + "px";
          });
        }
      }
    });
  }

  get navbarShow() {
    return this.$store.getters.navbarShow;
  }

  @Watch("navbarShow")
  onWatchNavbarShow() {
    setTimeout(() => {
      this.frozenColumnsBuilder();
    }, 500);
  }

  async onSearch() {
    //TODO
    await this.doSearch();
  }

  onPagingOption() {
    this.onSearch();
  }

  @Watch("pagingOption")
  sortChanged(newValue, oldValue) {
    if (newValue && oldValue) {
      this.pageBeforeSort = 0;
      if (
        newValue.sortBy !== oldValue.sortBy ||
        newValue.sortDesc !== oldValue.sortDesc
      ) {
        this.pageBeforeSort = oldValue.page;
      }
    }
  }

  headerThisPage = [];
  async doSearch(): Promise<void> {
    try {
      this.$util.showLoading();
      if (this.pageBeforeSort > 0) {
        const [column] = this.pagingOption.sortBy;
        const [isDesc] = this.pagingOption.sortDesc;
        this.items = this.sortItemsByColumn(this.items, column, isDesc);
      } else {
        await this.handleFilterTreatmentDatatbases();
        this.items = this.sortItemsByColumn(this.items, "product", false);
      }
      this.createHeader();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  sortItemsByColumn(items, column, isDesc) {
    return items.sort((a, b) => {
      const prev = "" + a[column];
      const next = "" + b[column];
      if (!isDesc) {
        if (!isNaN(Number(prev)) && !isNaN(Number(next))) {
          return prev === next ? 0 : prev < next ? -1 : 1;
        }
        return prev.toString().localeCompare(next.toString());
      } else {
        if (!isNaN(Number(prev)) && !isNaN(Number(next))) {
          return prev === next ? 0 : next < prev ? -1 : 1;
        }
        return next.toString().localeCompare(prev.toString());
      }
    });
  }

  createHeader() {
    // const setPointThisPageResult = intersectionWith(this.setPointsIsActive, this.setPointIdsThisPage, (o, id) => o.id === id);
    // this.headerThisPage = setPointThisPageResult.map(setPoint => ({
    //   sortable: false,
    //   text: setPoint.treatmentName,
    //   value: setPoint.id
    // }));
    this.headerThisPage = this.setPointsIsActive
      .map((setPoint) => ({
        sortable: false,
        text: setPoint.treatmentName,
        value: setPoint.id,
      }))
      .reverse();
    this.headers = this.BASE_HEADER.concat(this.headerThisPage);
    this.headers.push({
      text: this.$t("text.action"),
      value: "action",
      sortable: false,
    } as any);
  }

  setPointsIsActive = [];
  async handleGetMasterList() {
    let res;
    try {
      res = await new TreatmentMasterListsApi().getTreatments();
    } catch (error) {
      this.$util.showError(error);
      throw new Error("getTreatments Failed");
    }
    const isActive = (val): boolean => val.status === "Active";
    const typeProduct = "product";
    const typeInsect = "insect";
    const typePackage = "package";
    const typeTechnique = "technique";
    const typeSetpoint = "setpoint";
    this.productOptions = res.data.data.filter(
      (val) => val.treatmentType === typeProduct && isActive(val)
    );
    this.insectOptions = res.data.data.filter(
      (val) => val.treatmentType === typeInsect && isActive(val)
    );
    this.packageOptions = res.data.data.filter(
      (val) => val.treatmentType === typePackage && isActive(val)
    );
    this.techniqueOptions = res.data.data.filter(
      (val) => val.treatmentType === typeTechnique && isActive(val)
    );
    this.setPointsIsActive = res.data.data.filter(
      (val) => val.treatmentType === typeSetpoint && isActive(val)
    );
  }

  async handleFilterTreatmentDatatbases() {
    const body = {
      searchText: this.searchParam.keyword
        ? this.searchParam.keyword.trim()
        : undefined,
      product: this.searchParam.product ? this.searchParam.product : undefined,
      insects: this.searchParam.insect ? this.searchParam.insect : undefined,
      _package: this.searchParam.package ? this.searchParam.package : undefined,
      technique: this.searchParam.technique
        ? this.searchParam.technique
        : undefined,
      limit: this.pagingOption.itemsPerPage,
      page: this.pagingOption.page,
    } as TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest;
    try {
      await new TreatmentDatabasesApi()
        .getTreatmentDatatbasesSearch(body)
        .then((res) => {
          const data = res.data.data;
          this.totalRecord = res.data["count"];
          this.items = data.map((treatment) => {
            const item = {
              id: treatment.id,
              product: treatment.product
                ? treatment.product["treatmentName"]
                : "",
              insect: treatment.insects.map(
                (insect) => `${insect.treatmentName}`
              ),
              package: treatment.package
                ? treatment.package["treatmentName"]
                : "",
              technique: treatment.technique
                ? treatment.technique["treatmentName"]
                : "",
              treatmentFormat: treatment.treatmentFormat,
              treatmentTime: (treatment.treatmentTime && treatment.treatmentFormat) && `${treatment.treatmentTime} ${this.$t(`text.${treatment.treatmentFormat}`)}`,
              specificLocations: treatment.specificLocations,
              location: treatment.location,
              isPallet: treatment.isPallet ? this.$t("text.yes") : "",
              expiryTime: (treatment.expiryTime && treatment.expiryFormat) && `${treatment.expiryTime} ${this.$t(`text.${treatment.expiryFormat}`)}`,
            };
            this.handleDynamicHeader(item, treatment["setPoint"]);
            return item;
          });
        });
    } catch (error) {
      this.$util.showError(error);
      throw new Error("getTreatmentDatatbasesSearch Failed");
    }
  }

  setPointIdsThisPage: Array<string> = [];
  handleDynamicHeader(item, setPoints: any) {
    //TODO
    setPoints.forEach((setPoint) => {
      item[setPoint.id] = setPoint.value;
      const found = this.setPointIdsThisPage.find((id) => id === setPoint.id);
      if (found) return;
      this.setPointIdsThisPage.push(setPoint.id);
    });
  }

  selectedTreatment;
  selectedAction: ACTION;
  onSelectedTreatment({ item, action }): void {
    this.selectedTreatment = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.VIEW: {
        this.onViewTreatment();
        break;
      }
      case ACTION.EDIT: {
        this.onEditTreatment();
        break;
      }
      case ACTION.DELETE: {
        this.onDeleteTreatment();
        break;
      }
      default: {
        console.error(action);
        break;
      }
    }
  }

  onViewTreatment() {
    return this.$router.push({
      name: "treatment-detail",
      params: { id: this.selectedTreatment.id },
    });
  }

  onEditTreatment() {
    return this.$router.push({
      name: "edit-treatment",
      params: { id: this.selectedTreatment.id },
    });
  }

  onDeleteTreatment() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.delete.treatment");
  }

  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      this.doDelete();
    }
  }

  async doDelete() {
    try {
      this.$util.showLoading();
      await new TreatmentDatabasesApi().deleteTreatmentDatabase({
        id: this.selectedTreatment.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
    this.doSearch();
  }

  showAppliedLocationsDialog() {
    this.isShowAppliedLocationsDialog = true;
  }

  hideAppliedLocationsDialog() {
    this.isShowAppliedLocationsDialog = false;
  }

  async onViewDetailLocations(specificLocations) {
    try {
      this.$util.showLoading();
      const body: LocationsApiGetDetailLocationDatabaseRequest = {
        getLocationDatabaseDetailRequest: {
          locationIds: specificLocations
        } as GetLocationDatabaseDetailRequest
      };
      const res = await new LocationsApi().getDetailLocationDatabase(body);
      this.appliedLocations = res.data.data.map(location => ({
        customer: location.customerName,
        location: location.locationName,
      }));
      this.showAppliedLocationsDialog();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
